import { render, staticRenderFns } from "./PageConfiguration.vue?vue&type=template&id=869db12a&"
import script from "./PageConfiguration.vue?vue&type=script&lang=js&"
export * from "./PageConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('869db12a')) {
      api.createRecord('869db12a', component.options)
    } else {
      api.reload('869db12a', component.options)
    }
    module.hot.accept("./PageConfiguration.vue?vue&type=template&id=869db12a&", function () {
      api.rerender('869db12a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Production/PageConfiguration.vue"
export default component.exports